/**
 * kpiOvertimeRecordByUser模块接口列表
 */
import $http from '../utils/http'// 导入http中创建的axios实例

const kpiOvertimeRecordByUser = {
  // 添加或编辑
  insertOrUpdate(params) {
    return $http.post(`${global.API_URL}/sme/kpiOvertimeRecordByUser/insertOrUpdate`,params);
  },
  // 分页查询
  pageKpiOvertimeRecordByUser(params) {
    return $http.post(`${global.API_URL}/sme/kpiOvertimeRecordByUser/page`,params);
  },
  // 加班重复检查
  checkKpiOvertimeRecordByUser(params) {
    return $http.post(`${global.API_URL}/sme/kpiOvertimeRecordByUser/checkKpiOvertimeRecordByUser`,params);
  },
  // 删除
  deleteKpiOvertimeRecordByUser(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/kpiOvertimeRecordByUser/delete`,param);
  },
  //导出
  exportKpiOvertimeRecordByUser(params) {
    return $http.post(`${global.API_URL}/sme/kpiOvertimeRecordByUser/exportKpiOvertimeRecordByUser`, params, {
        responseType: 'arraybuffer',
        timeout: 1000 * 60 * 5
    });
  }
}

export default kpiOvertimeRecordByUser



// WEBPACK FOOTER //
// ./src/api/kpiOvertimeRecordByUser.js